import React, { useState } from "react";
import "../css/Gallery.css";
import Menu from "./Menu";
import useContent from "../../hooks/useContent";

const CATEGORIES = [
  { key: "all", label: "All" },
  { key: "Machine-Moving", label: "Machine Moving" },
  { key: "Warehousing", label: "Warehousing" },
  { key: "Truck-Services", label: "Truck / Crane Services" },
  { key: "Millwright-Services", label: "Millwright Services" },
];

const GalleryReact = () => {
  const allItems = useContent("portfolio", Menu);
  const [activeCategory, setActiveCategory] = useState("all");
  const [expandedImage, setExpandedImage] = useState(null);

  const items =
    activeCategory === "all"
      ? allItems
      : allItems.filter((el) => el.category === activeCategory);

  return (
    <div className="GalleryContainer">
      <br />
      <div className="GContainer">
        <ul className="GNav">
          {CATEGORIES.map((c) => (
            <li className="GNav-item" key={c.key}>
              <button
                className={
                  activeCategory === c.key ? "GNav-link Active" : "GNav-link"
                }
                onClick={() => setActiveCategory(c.key)}
              >
                {c.label}
              </button>
            </li>
          ))}
        </ul>
      </div>

      <div className="GContainer-fluid Gmt-4" id="GItemContainer">
        <div className="GRow">
          {items.map((elem) => {
            const { id, name, image, description } = elem;
            return (
              <div className="GCol-sm-4" key={id}>
                <div className="GCard">
                  <div
                    className="GCard-img"
                    onClick={() => setExpandedImage(image)}
                  >
                    <img src={image} alt={name} />
                  </div>
                  <div className="GCard-body">
                    <h5 className="GCard-title">{name}</h5>
                    {description && (
                      <p className="GCard-text">{description}</p>
                    )}
                    <div className="Gd-flex"></div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {expandedImage && (
        <div className="ImageModal" onClick={() => setExpandedImage(null)}>
          <span className="CloseIcon" onClick={() => setExpandedImage(null)}>
            &times;
          </span>
          <img src={expandedImage} alt="Expanded" />
        </div>
      )}
    </div>
  );
};

export default GalleryReact;
